export default "__VITE_ASSET__NR1HwkZ8__"